<!--出海视频-->
<template>
  <div class="extraction-container">
    <div class="ex-title" :style="{ color: theme.worksColor2 }">出海视频</div>

    <div class="cz-ch-box flex ac jb">
      <div class="ch-left-box">
        <div class="ch-title">选择需要翻译的视频</div>

        <div class="ch-info-box">
          <div v-if="upVideoUrl" style="width: 100%;height: 100%;position: relative">
            <!--            <img class="up-img" :src="upVideoUrl" alt="">-->
            <video ref="videoPlayer1" style="height: 100%;width: 100%; display: block; margin: 0 auto;" controls=""
                   :autoplay="false"
                   :src="upVideoUrl"></video>
            <div class="reset-btn-box">
              <el-button type="primary" icon="el-icon-refresh" @click="handleResetUp"
                         style="background: linear-gradient( 312deg, #6C14FF 0%, #01FBF5 100%);border: none">重新上传
              </el-button>
            </div>
          </div>

          <div v-else>
            <img v-if="progressStatus==''" class="up-mr"
                 src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.2_Icon_Video.png"
                 alt="">
            <div class="ch-choosed-btn cr tc">
              <el-upload
                v-if="progressStatus==''"
                ref="upload"
                :action="uploadUrl"
                :show-file-list="false"
                accept=".mp4,.mov,.MP4,.MOV"
                :on-progress="handleUping"
                :on-success="handleFileUpSuccess"
                :on-error="handleFileUpError"
                :on-remove="handleRemove"
                :before-upload="beforeAvatarUpload"
                multiple
                :limit="1"
                :headers="myHeaders"
                :data="needParam"
              >
                <el-button type="primary" icon="el-icon-plus" style="background: #6C14FF;border: none">选择文件</el-button>
              </el-upload>

              <div class="progress-box" v-if="progressStatus=='active'">
                <p class="fs20 tc">{{Math.round(progressPercentage)}}%</p>
                <el-progress :percentage="progressPercentage" :stroke-width="12" :show-text="false"></el-progress>
                <p class="tc">视频上传中...</p>
              </div>
            </div>
            <div class="ch-choosed-des" v-if="progressStatus==''">文件类型：m4v、mp4、mov、webm。<br>文件大小最大为 500MB,时长为10分钟之内<br>
              为了确保翻译准确，请上传语音清晰、没有歌声的视频
            </div>
          </div>

        </div>
      </div>
      <div class="ch-right-box">
        <div class="ch-title">选择语言</div>
        <div class="ch-info-box">
          <div class="choose-language flex ac jb">
            <div>初始化语言:</div>
            <el-select v-model="source_lang" placeholder="请选择初始化语言">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
                <div class="custom-option">
                  <img :src="item.icon" alt="" class="option-image"/>
                  <span>{{ item.name }}</span>
                </div>
              </el-option>
            </el-select>
          </div>
          <div class="choose-language flex ac jb">
            <div>目标语言:</div>
            <el-select v-model="target_lang" placeholder="请选择需要转化的目标语言">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
                <div class="custom-option">
                  <img :src="item.icon" alt="" class="option-image"/>
                  <span>{{ item.name }}</span>
                </div>
              </el-option>
            </el-select>
          </div>

          <div class="flex ac jb">
            <div class="speak-way-box cr" @click="handleChoosedWay(1)">
              <img v-if="!choosedWay1" class="info-img1"
                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.2_Icon_UnChoose.png" alt="">
              <img v-else class="info-img1"
                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.2_Icon_Choose.png" alt="">
              <div class="pp1">同步口型</div>
              <div class="pp2">翻译视频的音频，并保持说话人的口型同步</div>
              <img class="info-img2" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.2_Pic1.png"
                   alt="">
            </div>
            <div class="speak-way-box cr" @click="handleChoosedWay(2)">
              <img v-if="!choosedWay2" class="info-img1"
                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.2_Icon_UnChoose.png" alt="">
              <img v-else class="info-img1"
                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.2_Icon_Choose.png" alt="">
              <div class="pp1">仅翻译声音</div>
              <div class="pp2">只翻译视频中的音频，无口型同步</div>
              <img class="info-img2" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.2_Pic2.png"
                   alt="">
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="btn-bottom-box tr">
      <el-button type="primary" @click="handleSumbitFy"
                 style="background: linear-gradient( 312deg, #6C14FF 0%, #01FBF5 100%);border: none;transform: scale(1.2)">
        提交翻译
      </el-button>
    </div>


    <!--    <div class="js-info-box">-->
    <!--      <div class="js-info-header flex ac jb">-->
    <!--        <div class="flex ac jb cr">-->
    <!--          <div class="flex ac">-->
    <!--            <p class="mr30" :class="titleId==1?'title-active':''" @click="choosedTitle(1)">全部视频</p>-->
    <!--            <p class="mr30" :class="titleId==2?'title-active':''" @click="choosedTitle(2)">处理中</p>-->
    <!--            <p :class="titleId==3?'title-active':''" @click="choosedTitle(3)">已失败</p>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="tab-box-head flex ac">-->
    <!--        <div class="dv1">编号</div>-->
    <!--        <div class="dv2">翻译状态</div>-->
    <!--        <div class="dv3">视频信息</div>-->
    <!--        <div class="dv4">操作</div>-->
    <!--      </div>-->

    <!--      <div class="tab-box-info">-->
    <!--        <div class="flex ac" v-for="(item,index) in analyseList" :key="index">-->
    <!--          <div class="info-dv1">-->
    <!--            {{index+1}}-->
    <!--          </div>-->
    <!--          <div class="info-dv2 flex ac">-->
    <!--            <img v-if="item.status==3" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.5_Icon_Succeed.png" alt="">-->
    <!--            <img  v-else-if="item.status==4" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.5_Icon_Wrong.png" alt="">-->
    <!--            <span :class="item.status==3?'success-word':item.status==4 ? 'fail-word' :'' ">{{item.status_name}}</span>-->
    <!--          </div>-->
    <!--          <div class="info-dv3 flex ac">-->
    <!--            <img :src="item.cover" alt="">-->
    <!--            <div>-->
    <!--              <p class="te" style="width: 100%">{{item.desc}}</p>-->
    <!--              <p>{{item.size}}</p>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="info-dv4 flex ac cr" @click="handleDown(item)">-->
    <!--            <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.5_Icon_Download.png" alt="">-->
    <!--            <p>下载视频</p>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>
<script>
  import {
    delVideo,
    getVideoTranslate,
    uploadComplete,
    uploadSign,
    translateLang,
    postVideoTranslate
  } from '../api/user'

  export default {
    name: '',
    data() {
      return {
        link: '',
        titleId: 1,
        analyseList: [],

        needParam: {},
        uploadUrl: '',
        uploadDir: '',
        uploadSize: '',
        fileList: [],
        source_lang: '',
        target_lang: '',
        options: [],
        choosedWay1: true,
        choosedWay2: false,

        upVideoUrl: '',
        file_id: '',
        progressPercentage: 0, // 进度条的百分比
        progressStatus: '',
      }
    },
    computed: {
      myHeaders() {
        return {'x-token': window.localStorage.getItem('xcToken') || ''}
      },
      theme() {
        return this.$store.getters.getTheme;
      }
    },
    created() {
      this.getUploadSign()
      this.getOptions()
      this.getVideoTranslateInfo()
    },
    methods: {
      getOptions() {
        translateLang().then(res => {
          this.options = res.data
        })
      },
      getUploadSign() {
        uploadSign({file_type: 'video'}).then(res => {
          this.uploadUrl = res.data.host
          this.uploadDir = res.data.dir
          this.needParam = {
            'OSSAccessKeyId': res.data.access_key_id,
            'policy': res.data.policy,
            'signature': res.data.signature,
          }
        })
      },
      getVideoTranslateInfo() {
        getVideoTranslate().then(res => {
          this.analyseList = res.data.list
        })
      },

      handleChoosedWay(val) {
        if (val == 1) {
          this.choosedWay1 = true
          this.choosedWay2 = false
        }
        if (val == 2) {
          this.choosedWay1 = false
          this.choosedWay2 = true
        }
      },

      choosedTitle(val) {
        this.titleId = val
      },
      handleDown(item) {
        const that = this
        var xhr = new XMLHttpRequest()
        xhr.open('GET', item.url, true)
        xhr.responseType = 'blob' // 返回类型blob
        // 监听进度
        xhr.onprogress = function (e) {
          if (e.lengthComputable) {
            var percentComplete = 0
            var percentComplete = e.loaded / e.total * 100;
          }
        }
        xhr.onload = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            console.log('开始下载')
            const blob = this.response
            // 转换一个blob链接
            const u = window.URL.createObjectURL(new Blob([blob]))
            const a = document.createElement('a')
            var str = ''
            str = item.name + '.mp4'
            a.download = str
            a.href = u
            document.body.appendChild(a)
            a.click()
            console.log('结束')
            that.$message.success('下载成功！')
            window.URL.revokeObjectURL(u)
          } else {
            console.log('失败了')
            that.$message.error('下载失败！')
          }
        }
        xhr.onerror = function () {
          that.$message.error('下载失败！')
        }
        xhr.send()
      },
      handleResetUp() {
        this.upVideoUrl = ''
        this.file_id = ''
        this.$refs.upload && this.$refs.upload.clearFiles();
      },
      // 提交翻译
      handleSumbitFy() {
        if (!this.file_id) {
          this.$message.error('请上传视频！')
          return false
        }
        if (!this.source_lang) {
          this.$message.error('请选择初始化语言！')
          return false
        }
        if (!this.target_lang) {
          this.$message.error('请选择翻译后的语言！')
          return false
        }
        let mode = null
        if (this.choosedWay1) {
          mode = 1
        }
        if (this.choosedWay2) {
          mode = 2
        }
        this.loading = this.$loading({
          lock: true,
          text: '翻译中,请等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.6)'
        });

        postVideoTranslate({
          file_id: this.file_id,
          source_lang: this.source_lang,
          target_lang: this.target_lang,
          mode: mode
        }).then(res => {
          if (res.code == 0) {
            this.file_id = ''
            this.upVideoUrl = ''
            this.$message.success(res.msg)
            this.$store.dispatch('updatePoints')
            this.$alert('视频翻译成功，您可以在视频创作页面查看', '提交成功', {
              confirmButtonText: '确定',
              callback: action => {
                this.$router.push({
                  path: '/works',
                  query: {
                    type1: 0,
                    type2: 3,
                  }
                })
              }
            });
          }
          this.loading.close()
        }).catch(error => {
          this.loading.close()
        })
      },

      // 获取视频时长
      getVideoDuration(url) {
        return new Promise((resolve, reject) => {
          const video = document.createElement('video');
          video.addEventListener('loadedmetadata', () => {
            resolve(video.duration);
          });
          video.src = url;
        });
      },

      beforeAvatarUpload(file) {
        this.loading = this.$loading({
          lock: true,
          text: '上传中,请等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.6)'
        });
        var file_type = file.name.split('.').slice(-1)
        const isLt500M = file.size / 1024 / 1024 < 500
        const fileExtension = file.name.split('.').pop().toLowerCase()
        if (fileExtension != 'mp4' && fileExtension != 'mov' || !isLt500M) {
          this.$message.error('请上传500MB以内的MP4/MOV格式的视频')
          return false
        } else {
          var file_name = this.uploadDir + Date.parse(new Date()) + '' + parseInt(Math
            .random() * 100) + '.' + file_type
          this.needParam.key = file_name
          this.uploadSize = file.size
        }
      },
      handleRemove() {
        this.fileList = []
      },
      handleUping(event) {
        this.loading = this.$loading({
          lock: true,
          text: '',
          spinner: 'none',
          background: 'rgba(0, 0, 0, 0.6)'
        });
        this.progressStatus = 'active';
        this.progressPercentage = event.percent;
        if (event.percent === 100) {
          this.progressStatus = 'success';
          setTimeout(() => {
            this.progressPercentage = 0;
            this.progressStatus = '';
          }, 300);
        }
      },
      async handleFileUpSuccess(file) {
        const url = `${this.uploadUrl}/${this.needParam.key}`
        // 获取时长
        let time = await this.getVideoDuration(url)
        uploadComplete({
          file_type: 'video',
          size: this.uploadSize,
          url: url,
          duration: time
        }).then(res => {
          if (res.data.url && res.data.file_id) {
            this.upVideoUrl = res.data.url
            this.file_id = res.data.file_id
            this.$message.success('上传成功')
            this.loading.close();
          }
        }).catch(() => {
          this.loading.close();
        })
        this.$refs.upload && this.$refs.upload.clearFiles();
      },
      handleFileUpError() {
        this.$message.error('上传失败，请重新上传')
        this.loading.close();
      }
    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {
    },
  }
</script>

<style lang="scss" scoped>
  .extraction-container {
    height: 100vh;
    width: 100%;
    position: relative;

    .ex-title {
      font-weight: 500;
      font-size: 24px;
      color: #FFFFFF;
      margin: 22px 40px;
    }

    .cz-ch-box {
      width: 1640px;
      margin: 0 auto;

      .ch-left-box {
        width: 800px;
        height: 530px;
        background: #191B2F;
        border-radius: 12px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        padding: 24px;

        .ch-title {
          font-weight: 500;
          font-size: 16px;
          color: #FFFFFF;
          text-align: left;
        }

        .ch-info-box {
          width: 750px;
          height: 440px;
          background: rgba(255, 255, 255, 0.02);
          border-radius: 8px;
          border: 1px solid rgba(255, 255, 255, 0.5);
          margin: 16px auto 0;

          .up-img {
            height: 100%;
            width: auto;
            object-fit: contain;
            display: block;
            margin: 0 auto;
          }

          .reset-btn-box {
            position: absolute;
            left: calc(50% - 50px);
            top: 50%;
          }

          .up-mr {
            width: 68px;
            height: 68px;
            display: block;
            margin: 104px auto 22px;
          }

          .ch-choosed-btn {
            margin: 0 auto;
          }

          .ch-choosed-des {
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFFAA;
            text-align: center;
            margin-top: 10px;
          }
        }
      }

      .ch-right-box {
        width: 800px;
        height: 530px;
        background: #191B2F;
        border-radius: 12px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        padding: 24px;

        .ch-title {
          font-weight: 500;
          font-size: 16px;
          color: #FFFFFF;
          text-align: left;
        }

        .ch-info-box {
          width: 750px;
          height: 392px;
          margin: 16px auto 0;

          .choose-language {
            width: 740px;
            height: 48px;
            background: rgba(255, 255, 255, 0.02);
            border-radius: 8px;
            border: 1px solid rgba(255, 255, 255, 0.2);

            font-weight: 400;
            font-size: 14px;
            color: #FFFFFFAA;
            margin: 0 auto 10px;
            padding: 0 20px;
          }

          .speak-way-box {
            position: relative;
            width: 370px;
            height: 320px;
            background: rgba(255, 255, 255, 0.05);
            border-radius: 8px;
            margin-top: 15px;

            .pp1 {
              font-weight: 500;
              font-size: 16px;
              color: #FFFFFF;
              text-align: center;
              margin-top: 40px;
            }

            .pp2 {
              font-weight: 400;
              font-size: 14px;
              color: #FFFFFFAA;
              text-align: center;
              margin: 20px 0;
            }

            .info-img1 {
              cursor: pointer;
              width: 24px;
              height: 24px;
              position: absolute;
              right: 12px;
              top: 12px;
            }

            .info-img2 {
              width: 240px;
              height: 170px;
              display: block;
              margin: 0 auto;
            }
          }
        }
      }
    }

    .js-info-box {
      width: 1640px;
      height: 472px;
      background: #191B2F;
      border-radius: 12px;
      margin: 16px auto 0;
    }

    .js-info-header {
      height: 80px;
      width: 100%;
      border-bottom: 1px solid #393C4E;
      padding: 0 40px;

      font-weight: 500;
      font-size: 18px;
      color: #FAFAFAAA;

      .title-active {
        font-weight: 500;
        font-size: 18px;
        color: #FAFAFA;
      }
    }

    .tab-box-head {
      width: 1560px;
      height: 40px;
      background: rgba(117, 123, 195, 0.2);
      border-radius: 2px;
      margin: 24px auto 0;
      text-align: left;

      .dv1 {
        padding-left: 20px;
        width: 150px;
      }

      .dv2 {
        padding-left: 20px;
        width: 150px;
      }

      .dv3 {
        padding-left: 20px;
        width: 1100px;
      }

      .dv4 {
        padding-left: 20px;
        width: 160px;
      }
    }

    .tab-box-info {

      width: 1560px;
      height: 80px;
      background: rgba(84, 90, 154, 0.1);
      border-radius: 2px;
      margin: 0 auto;

      .info-dv1 {
        padding-left: 20px;
        width: 150px;
      }

      .info-dv2 {
        width: 150px;
        padding-left: 20px;
        font-weight: 400;
        font-size: 14px;

        img {
          width: 20px;
          height: 20px;
        }

        .success-word {
          color: #32B052;
        }

        .fail-word {
          color: #D9A030;
        }
      }

      .info-dv3 {
        width: 1100px;

        p {
          padding: 0;
          margin: 0;
        }

        padding: 16px 20px;

        img {
          width: 48px;
          height: 48px;
          border-radius: 6px;
          margin-right: 16px;
        }

      }

      .info-dv4 {
        width: 160px;
        font-weight: 500;
        font-size: 14px;
        color: #04F6F6;

        img {
          width: 20px;
          height: 20px;
          display: block;
          margin-right: 4px;
        }
      }
    }
  }

  .btn-bottom-box {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 150px;
    background: #0D1027;
    box-shadow: 0px -1px 0px 0px rgba(250, 250, 250, 0.1);
    border-left: 1px rgba(250, 250, 250, 0.1) solid;
    padding-top: 20px;
    padding-right: 60px;
  }

  .progress-box {
    border-radius: 8px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
    padding: 150px 15px 0;
  }
</style>
<style lang="scss">
  .im-sr-box {
    .el-input__inner {
      background: none;
      border: none;
      color: #ffffff;
    }

    .el-input__inner:focus {
      border-color: #dcdfe6 !important; /* 设置为输入框的默认边框颜色 */
      outline: none; /* 去掉轮廓线 */
    }
  }

  .custom-option {
    display: flex;
    align-items: center;
  }

  .option-image {
    width: 20px; /* 根据需要调整图片大小 */
    height: 20px;
    margin-right: 8px;
  }

  .choose-language {
    .el-input__inner {
      background: none;
      border: none;
      color: #ffffff;
      text-align: center;
    }

    .el-input__inner:focus {
      border-color: #dcdfe6 !important; /* 设置为输入框的默认边框颜色 */
      outline: none; /* 去掉轮廓线 */
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/sea.vue